import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  overflow: hidden;
  cursor: pointer;
`;

const LogoIcon = styled.img`
  height: 65px;
  width: auto;
  object-fit: cover;
  transform: scale(1.15);

  @media (max-width: 768px) {
    height: 50px;
  }
`;

const Logo: React.FC = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <LogoContainer className="logo-container" onClick={handleLogoClick}>
      <LogoIcon className="logo-icon" src="/lee_freund_logo_new.png" alt="לי פרוינד - פסיכולוגית חינוכית מומחית" />
    </LogoContainer>
  );
};

export default Logo;